"use strict";
module.exports = require("@apidevtools/swagger-parser");
